import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeType } from '@/modules/common';

const commonInputStyles = ({
  theme,
  disabled,
  hasAttachmentsButton,
}: {
  theme: ThemeType;
  disabled?: boolean;
  hasAttachmentsButton?: boolean;
}) => css`
  width: 100%;
  height: 34px;
  max-height: 104px;
  padding: 9px 17px 9px ${hasAttachmentsButton ? '3px' : '17px'};
  color: #000;
  line-height: 20px;
  font-size: 13px;
  font-family: ${theme.fontFamily};
  opacity: ${disabled ? '.6' : 1};
  overflow: hidden !important;
  resize: none;
  border: none;
  border-radius: ${hasAttachmentsButton ? '0' : '6px 0 0 6px'};
  background-color: #f2f2f2;
  outline: none;
  box-sizing: border-box;
  transition: all 0.3s ease;

  &::placeholder {
    color: #6a6a6a;
  }

  ${theme.input.styles}

  @media (${theme.mediaMobile}) {
    font-size: 16px;
    ${theme.input.mobile};
  }

  @media not (${theme.mediaMobile}) {
    ${theme.input.desktop};
  }
`;

export const TextArea = styled.textarea<{ hasAttachmentsButton?: boolean }>`
  ${commonInputStyles}
`;

export const Input = styled.input<{ hasAttachmentsButton?: boolean }>`
  ${commonInputStyles}
`;
